import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { money } from "@/lib/booking";
import { Stepper, label } from "./ui";

export function useAddons(tourId) {
    const [addons, setAddons] = useState([]);
    useEffect(() => {
        if (!supabase) return;
        supabase.from("booking_addons").select("*").eq("active", true).order("sort_order")
            .then(({ data }) => setAddons((data || []).filter((a) => !a.tour_ids?.length || a.tour_ids.includes(tourId))));
    }, [tourId]);
    return addons;
}

export function AddonsPicker({ addons, value, onChange }) {
    if (!addons.length) return null;
    return (
        <fieldset data-testid="addons-picker">
            <legend className={label}>Adicionais (opcional)</legend>
            <div className="space-y-2">
                {addons.map((a) => (
                    <div key={a.id} className="flex items-center gap-4 rounded-2xl border border-ink/10 p-3" data-testid={`addon-${a.id}`}>
                        {a.image_url && <img src={a.image_url} alt={a.title} loading="lazy" className="h-14 w-14 rounded-xl object-cover" />}
                        <span className="flex-1 text-sm"><strong>{a.title}</strong>
                            <span className="block text-xs text-dim">{a.description}{a.description ? " · " : ""}{money(a.price)}</span></span>
                        <Stepper title={a.title} testid={`addon-qty-${a.id}`} value={value[a.id] || 0} max={a.max_quantity}
                            onChange={(n) => onChange({ ...value, [a.id]: n })} />
                    </div>
                ))}
            </div>
        </fieldset>
    );
}
